import { Box, Flex, SimpleGrid } from '@chakra-ui/react';
import { Avatar, Badge, Tag, Text } from '@kula-ai/components';
import type { DashboardCard } from '../../../types';
import { badgeMeta, toneBadgeColor } from './helpers';

// Fixed 3-up grid so cards keep a stable width.
export const CardGrid = ({ cards }: { cards: DashboardCard[] }) => (
  <SimpleGrid columns={3} spacing="12px">
    {cards.map((c, i) => (
      <Box
        key={`${c.title}-${i}`}
        minW="0"
        border="1px solid"
        borderColor="border-color"
        borderRadius="10px"
        px="12px"
        py="10px"
      >
        <Flex align="center" justify="space-between" gap="8px" minW="0">
          <Flex align="center" gap="8px" minW="0">
            <Avatar src={c.logo} name={c.title} shape="square" size={22} />
            <Text variant="h4" truncate title={c.title}>
              {c.title}
            </Text>
          </Flex>
          {c.badge && (
            <Badge
              type="outline"
              color={badgeMeta(c.badge).color ?? toneBadgeColor(c.tone)}
              // Badge has no size prop; shrink the label via className.
              className="px-1.5 [&>span]:text-xs"
            >
              {badgeMeta(c.badge).label}
            </Badge>
          )}
        </Flex>
        {c.body && (
          <Text variant="p" style={{ display: 'block', marginTop: 2 }}>
            {c.body}
          </Text>
        )}
        {c.detail && (
          <Text
            variant="p"
            className="text-[12px] text-secondary-500"
            style={{ display: 'block', marginTop: 2 }}
          >
            {c.detail}
          </Text>
        )}
        {c.tags && c.tags.length > 0 && (
          <Flex wrap="wrap" gap="4px" mt="6px">
            {c.tags.map((t) => (
              <Tag key={t} label={t} size="sm" variant="outline" />
            ))}
          </Flex>
        )}
      </Box>
    ))}
  </SimpleGrid>
);
